export class ScheduledCommand {
    constructor(
      id,
      description,
      command,
      args,
      cronExpression,
      lastExecution,
      lastReturnCode,
      lastOutput,
      disabled,
      running
    ) {
        this.id = id;
        this.description = description;
        this.command = command;
        this.arguments = args;
        this.cronExpression = cronExpression;
        this.lastExecution = lastExecution;
        this.lastReturnCode = lastReturnCode;
        this.lastOutput = lastOutput;
        this.disabled = disabled;
        this.running = running;
    }
    static createFromResponseData(data) {
      return new ScheduledCommand(
        data.id,
        data.description,
        data.command,
        data.arguments,
        data.cronExpression,
        data.lastExecution,
        data.lastReturnCode,
        data.lastOutput,
        data.disabled,
        data.running,
      );
    }
  };